import React from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import pMarkLogo from "images/logo/pmark.png"; // Adjust path as needed

const PrivacyMarkXs = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        maxWidth: "100%",
        overflow: "hidden",
      }}
      id={id}
    >
      {/* iOS-style card */}
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 0 }}>
          {/* Header with logo */}
          <Box
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            <Box
              component="img"
              src={pMarkLogo}
              alt="P Mark Logo"
              sx={{
                width: 32,
                height: 32,
                objectFit: "contain",
              }}
            />
            <Typography
              variant="subtitle1"
              component="h2"
              fontWeight="600"
              sx={{ ml: 1.5 }}
            >
              {t("privacy-policy.privacy-mark.title")}
            </Typography>
          </Box>

          {/* Description */}
          <Box sx={{ p: 2 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#666",
                mb: 2,
              }}
            >
              {t("privacy-policy.privacy-mark.description")}
            </Typography>
          </Box>

          {/* Registration info in iOS list style */}
          <ListItem
            sx={{
              borderTop: "1px solid rgba(0,0,0,0.05)",
              py: 1.5,
            }}
          >
            <ListItemText
              primary={t("privacy-policy.privacy-mark.registration")}
              primaryTypographyProps={{
                variant: "body2",
                sx: { color: "#333" },
              }}
            />
          </ListItem>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PrivacyMarkXs;
